<template>
  <div id="header" class="bg-1">
    <div
      class="header header-mobile text-light flex-column align-left"
      v-if="this.windowWidth < 900"
      :style="navMobile ? 'left: 0;' : ''"
    >
      <div v-for="(item, index) in routes" :key="index" class="subtitle-1">
        <div class="flex align-center" @click="toRoute(item)">
          {{ item.name }}
          <svg
            v-if="item.submenu"
            width="12" height="14"
            viewBox="0 4 20 1"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            :style="!item.closed ? 'transform: rotate(180deg)' : ''"
          >
            <path d="M1 1L9 9L17 1" stroke="#FAFAFA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div v-if="item.submenu" v-show="!item.closed" class="submenu-item flex-column align-left">
          <div
            v-for="(sub, index) in item.submenu"
            :key="index"
            class="subtitle-5"
            @click="toSubRoute(item, sub)"
          >
            {{ sub.text }}
          </div>
          <div
            v-if="item.name === 'Produtos'"
            class="subtitle-5"
            @click="toRoute(routeCatalogos)"
          >
            Catálogos
          </div>
        </div>
      </div>
      <div class="subtitle-1"><a href="https://blogdatopazio.blogspot.com/" style="color: #fafafa" target="_blank">Blog</a></div>
      <div class="subtitle-1"><a href="/area-dos-representantes" style="color: #fafafa">
        <img :src="require(`@/assets/focco.png`)" width="100">
      </a></div>
    </div>
    <div class="flex align-center justify-space-between header-fixed">
      <a href="/">
        <div class="logo">
          <div class="santa-hat" v-if="isChristmasSeason">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.0894 12.8551C17.0172 13.2886 16.992 14.181 16.8889 14.548C16.8082 14.8355 16.7294 15.0784 16.6409 15.2945C16.2212 16.3188 14.8058 16.2029 13.9539 15.4961C11.8935 13.7866 8.28389 11.3723 5.44925 11.5199C3.60053 11.5199 2.78441 12.2557 1.4747 12.2187C0.462474 12.1901 0.419678 11.1702 0.419678 10.7253C0.419678 9.17739 1.55009 6.94355 2.39598 5.63987C2.67037 5.21699 3.12148 4.94317 3.6252 4.92362C5.66959 4.84428 8.66419 5.47922 10.055 6.05561C11.8624 6.80443 17.4742 5.01432 18.0654 8.17788C18.2019 8.90825 17.2877 11.6655 17.0894 12.8551Z" fill="#555"/>
              <path d="M14.058 15.0757C14.4647 16.1463 13.7261 17.6881 12.6525 18.096C11.5789 18.5039 9.97218 17.4173 9.56547 16.3467C9.15876 15.2762 9.7717 14.268 10.8453 13.8601C11.9189 13.4522 13.6513 14.0051 14.058 15.0757Z" fill="#555"/>
              <path d="M16.1484 13.3764C16.1484 13.8639 16.1168 14.2139 16.0254 14.5047C15.7048 15.5244 14.2246 15.3306 13.408 14.6408C11.4715 13.0052 8.10014 10.6455 5.47229 10.7758C3.75121 10.7758 2.66599 11.6546 1.44671 11.6218C0.504369 11.5964 0.51242 10.995 0.51242 10.6008C0.51242 9.23692 1.64568 6.94835 2.46272 5.68202C2.72996 5.26782 3.17423 5.00794 3.66678 4.98872C5.59668 4.91345 8.47203 5.42532 9.76002 5.93343C11.8312 6.75022 16.1484 10.557 16.1484 13.3764Z" fill="white"/>
              <path d="M15.582 12.1143C15.6921 12.1143 15.8002 12.1226 15.9062 12.1348C16.0599 12.561 16.1484 12.9779 16.1484 13.376C16.1484 13.8635 16.1168 14.2141 16.0254 14.5049C15.7047 15.5244 14.2248 15.3303 13.4082 14.6406C13.3452 14.5874 13.2799 14.5342 13.2139 14.4795C13.1939 14.3736 13.1816 14.265 13.1816 14.1543C13.1819 13.0278 14.2565 12.1143 15.582 12.1143Z" fill="#fff"/>
              <path d="M17.9819 8.23983C17.9819 11.3505 17.1426 10.8132 16.0906 12.9176C15.6714 10.8974 15.1672 13.4229 12.5547 15.1421C11.8451 15.609 11.9397 15.5814 11.4871 15.1421C11.4871 13.1202 10.9116 8.10991 10.1557 7.0614C9.27191 5.83531 5.67518 4.99652 3.7019 4.99652C5.38417 2.01401 5.3475 0.159215 6.86264 0.15918C8.88407 0.15918 10.5602 3.64347 13.0577 4.53618C15.9771 5.57968 17.9819 6.56336 17.9819 8.23983Z" fill="#D8001B"/>
              <path d="M13.0397 15.0393C13.3801 15.9353 13.0054 17.1366 12.1095 17.477C11.2135 17.8174 10.1356 17.1678 9.79528 16.2719C9.45491 15.376 9.9658 14.533 10.8617 14.1927C11.7577 13.8523 12.6994 14.1434 13.0397 15.0393Z" fill="#fff"/>
              <path d="M17.9771 8.11267C17.9796 8.15455 17.9819 8.19685 17.9819 8.23962C17.9819 11.3503 17.1423 10.813 16.0903 12.9174C15.9222 12.1074 15.7423 12.0298 15.4165 12.3363C16.0977 11.45 17.5889 10.3388 17.9565 8.11169C17.9634 8.1117 17.9702 8.11245 17.9771 8.11267Z" fill="#a00015"/>
            </svg>
          </div>
          <img src="@/assets/logos/logo-icon.png" height="42" id="logo-icon"/>
        </div>
      </a>
      <div class="header flex align-center" v-if="this.windowWidth > 900">
        <div class="nav flex">
          <router-link
            v-for="route in routes"
            :key="route.name"
            :to="route.nameRoute == 'Blog' ? { name: route.nameRoute } : { path: route.route }"
            :target="route.nameRoute == 'Blog' ? '_blank' : '_self'"
            class="navbar text-light body-3 flex-column justify-space-between align-center"
          >
            {{ route.name }}
            <ul type="none" class="submenu flex-column" v-if="route.submenu">
              <li v-for="(item, index) in route.submenu" :key="index">
                <router-link
                  v-if="route.nameRoute == 'Products'"
                  :to="{ name: route.nameRoute, params: { categoria: item.route, title: item.text } }"
                  class="text-light">
                  {{ item.text }}
                </router-link>
                <router-link v-else :to="{ name: item.nameRoute }" class="text-light">
                  {{ item.text }}
                </router-link>
              </li>
              <li v-if="route.nameRoute == 'Products'">
                <router-link
                  class="text-light"
                  :to="routeCatalogos.route"
                >
                  Catálogos
                </router-link>
              </li>
            </ul>
          </router-link>
          <a href="https://blogdatopazio.blogspot.com/" target="_blank" class="text-light body-3">Blog</a>
          <a href="/area-dos-representantes" class="text-light body-3">
            <img :src="require(`@/assets/focco.png`)" width="80">
          </a>
        </div>
      </div>
      <ToggleAnimated v-else :check-change="navMobile" @check-toggle="checkChange"/>
<!--      <div class="menu-hamburguer" @click="navMobile = true" v-else>-->
<!--        <svg width="34" height="30" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--          <path d="M0 10H14V8H0V10ZM0 0V2H14V0H0ZM0 6H14V4H0V6Z" fill="#FAFAFA"/>-->
<!--        </svg>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ToggleAnimated from './ToggleAnimated'

export default {
  name: 'Header',
  components: {
    ToggleAnimated
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      scrollY: window.scrollY,
      navMobile: false,
      routeCatalogos: { name: 'Catálogos', route: '/catalogos', nameRoute: 'Catalogs' },
      // Rotas base (categorias de produtos vêm da API via computed)
      baseRoutes: [
        { name: 'Início', route: '/', nameRoute: 'Home' },
        {
          name: 'O Grupo',
          nameRoute: 'About',
          route: '/o-grupo',
          submenu: [
            { text: 'Nossa História', route: 'nossa-historia', nameRoute: 'OurStory' },
            { text: 'A Topázio', route: 'a-topazio', nameRoute: 'TheTopazio' }
          ],
          closed: true
        },
        {
          name: 'Produtos',
          nameRoute: 'Products',
          route: '/produtos',
          submenu: [], // Preenchido dinamicamente via computed
          closed: true
        },
        { name: 'Onde Comprar', nameRoute: 'WhereBuy', route: '/onde-comprar' },
        {
          name: 'Para Lojistas',
          route: '/lojistas',
          nameRoute: 'Logisticians',
          submenu: [
            { text: 'Ser um afiliado', route: 'ser-um-afiliado', nameRoute: 'Affiliate' },
            { text: 'Representantes', route: 'representantes', nameRoute: 'Representatives' }
          ],
          closed: true
        },
        { name: 'Fale Conosco', route: '/fale-conosco', nameRoute: 'ContactUs' }
      ]
    }
  },
  computed: {
    ...mapGetters(['productCategories', 'siteConfig']),
    isChristmasSeason () {
      const today = new Date()
      const month = today.getMonth()
      const day = today.getDate()
      return month === 11 && day >= 20 && day <= 29
    },
    // Monta o menu com categorias dinâmicas da API (vazio se não retornar)
    routes () {
      return this.baseRoutes.map(route => {
        if (route.nameRoute === 'Products') {
          // Usa categorias da API (vazio se não retornar)
          const categories = this.productCategories.map(cat => ({
            text: cat.name,
            route: cat.slug
          }))
          return { ...route, submenu: categories }
        }
        return route
      })
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.scrollY = window.scrollY
    })
  },
  methods: {
    checkChange (payload) {
      this.navMobile = payload.value
    },
    toRoute (item) {
      const index = this.routes.findIndex(r => r.name === item.name)
      if (item.submenu) {
        this.routes[index].closed = !this.routes[index].closed
      } else if (this.$route.path !== item.route) {
        this.$router.push({ path: item.route })
        this.navMobile = false
      }
    },
    toSubRoute (item, sub) {
      if (item.nameRoute === 'Products') {
        this.$router.push({ name: item.nameRoute, params: { categoria: sub.route, title: sub.text } })
        this.navMobile = false
      } else {
        this.$router.push({ name: sub.nameRoute })
        this.navMobile = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/colors';
#header {
  .logo {
    position: relative;
    .santa-hat {
      position: absolute;
      top: -10px;
      left: 18px;
      z-index: 10;
      svg {
        width: 22px;
        height: 22px;
        transform: rotate(15deg);
      }
    }
    &:hover .santa-hat svg {
      animation: jiggle 0.4s ease-in-out;
    }
  }
  .logo img:hover {
    filter: brightness(100);
  }
  @keyframes jiggle {
    0%, 100% { transform: rotate(15deg); }
    25% { transform: rotate(7deg); }
    50% { transform: rotate(21deg); }
    75% { transform: rotate(11deg); }
  }
  .header {
    padding: 12px 30px;
  }
  .header-fixed {
    padding: 7px 20px;
  }
  .header-mobile {
    height: 100vh;
    background: rgba(0, 82, 69, 0.97);
    width: 65vw;
    position: absolute;
    left: -100vw;
    transition: all .4s ease;
    gap: 20px;
    .subtitle-1:nth-child(1) {
      margin-top: 30px;
    }
    svg {
      margin: 4px 0 0 6px;
      transition: all .4s ease;
    }
    .submenu-item {
      margin: 6px 0 0 15px;
      gap: 6px;
    }
  }
  .nav {
    a {
      line-height: 22px;
      opacity: .6;
      border: none;
      max-height: 23px;
      margin-left: 20px;
    }
    a:after {
      content: '';
      opacity: 0;
      background: map-get($mainColors , 'light' );
      height: 1px;
      width: 110%;
      transition: all .3s ease-in-out;
    }
    a:hover {
      color: map-get($mainColors , 'light' );
      opacity: 1;
    }
    a.router-link-exact-active {
      color: map-get($mainColors , 'light' );
      opacity: 1;
      border: none;
    }
    a.router-link-exact-active:after {
      opacity: 1;
    }
    .navbar {
      position: relative;
      transition: all .3s ease;
      .submenu {
        background-color: rgba(60, 60, 60, 0.71);
        border-radius: 5px;
        top: 10px;
        left: 0;
        display: none;
        position: absolute;
        text-align: left;
        min-width: 150%;
        padding-top: 5px;
        padding-bottom: 5px;
        li a {
          margin-left: -50px;
          padding: 0 20px;
          opacity: 0.6;
          transition: all .3s ease;
        }
        a:hover {
          opacity: 1;
        }
      }
    }
    .navbar:hover > .submenu {
      display: block;
    }
  }
  @media screen and (max-width: 525px) {
    .header {
      padding: 12px 20px;
    }
  }
}
</style>